// extracted by mini-css-extract-plugin
module.exports = {"popupBox":"loadingspiner_popupBox__2J1Q7","box":"loadingspiner_box__13O7Y"};